// CUSTOM DEVELOPMENT FOR CUSTOMER START
function buildQuizResultUrl(answers, orderedStepIds) {
  var ids = orderedStepIds || [];
  var list = answers || [];

  var answerByStep = {};
  list
    .filter(function (item) {
      return ids.indexOf(item.quiz) !== -1;
    })
    .forEach(function (item) {
      answerByStep[item.quiz] = item;
    });

  var basePath = "/collections/all";
  var filters = [];

  ids.forEach(function (id, index) {
    var answer = answerByStep[id];
    if (!answer) return;

    var value = (answer.value || "").trim();
    if (!value) return;

    var type = answer.type;
    if (!type) {
      type =
        value.charAt(0) === "/" || value.indexOf("=") === -1
          ? "collection"
          : "filter";
    }

    if (type === "collection") {
      if (index === 0) {
        basePath = value.charAt(0) === "/" ? value : "/collections/" + value;
      }
    } else {
      filters.push(value);
    }
  });

  var filtersStr = filters.join("&");
  return filtersStr ? basePath + "?" + filtersStr : basePath;
}

function normalizeLabel(s) {
  return String(s == null ? "" : s).replace(/\s+/g, " ").trim().toLowerCase();
}

function decodeAnswerValue(rawValue) {
  var v = String(rawValue == null ? "" : rawValue);
  var eq = v.indexOf("=");
  if (eq !== -1) v = v.slice(eq + 1);
  v = v.replace(/\+/g, " ");
  try {
    v = decodeURIComponent(v);
  } catch (e) {}
  return normalizeLabel(v);
}

function findFilterValueForValue(filtersData, rawValue) {
  var needle = decodeAnswerValue(rawValue);
  if (!filtersData || !filtersData.filters || !needle) return null;
  for (var i = 0; i < filtersData.filters.length; i++) {
    var values = filtersData.filters[i].values || [];
    for (var j = 0; j < values.length; j++) {
      var cv = values[j];
      if (normalizeLabel(cv.label) === needle) return cv;
      if (decodeAnswerValue(cv.value) === needle) return cv;
    }
  }
  return null;
}

function answerMatchesCollection(filtersData, rawValue) {
  var parts = String(rawValue == null ? "" : rawValue).split("&");
  for (var i = 0; i < parts.length; i++) {
    if (!parts[i]) continue;
    var hit = findFilterValueForValue(filtersData, parts[i]);
    if (hit && (typeof hit.count !== "number" || hit.count > 0)) return true;
  }
  return false;
}

if (typeof module !== "undefined" && module.exports) {
  module.exports = {
    buildQuizResultUrl: buildQuizResultUrl,
    findFilterValueForValue: findFilterValueForValue,
    answerMatchesCollection: answerMatchesCollection
  };
}
// CUSTOM DEVELOPMENT FOR CUSTOMER END

if (typeof document !== "undefined") document.addEventListener("DOMContentLoaded", function () {
  const quizStart = document.querySelector(".quiz__page-start");
  const quizSteps = document.querySelectorAll(".quiz__step");
  const quizEnd = document.querySelector(".quiz__page-end");
  const showResultsBtn = document.querySelector(".button--show-results");

  let totalSteps = quizSteps.length;
  let currentStepIndex = parseInt(localStorage.getItem("quizCurrentStep")) || -1; // get latest step from local storage

  // CUSTOM DEVELOPMENT FOR CUSTOMER START
  const quizContainerEl = document.getElementById("quiz");
  const isDynamic = !!(quizContainerEl && quizContainerEl.dataset.dynamicFilters === "true");
  const filtersView = (quizContainerEl && quizContainerEl.dataset.filtersView) || "quiz-filters";
  let skipped = new Set();

  function visibleIndices() {
    const out = [];
    for (let i = 0; i < totalSteps; i++) {
      if (!skipped.has(i)) out.push(i);
    }
    return out;
  }
  function prevVisible(from) {
    for (let i = from - 1; i >= 0; i--) {
      if (!skipped.has(i)) return i;
    }
    return null;
  }

  function setButtonLoading(btn, loading) {
    if (!btn) return;
    btn.classList.toggle("is-loading", loading);
    if (loading) {
      btn.setAttribute("aria-busy", "true");
      if (btn.tagName === "BUTTON") btn.disabled = true;
    } else {
      btn.removeAttribute("aria-busy");
      if (btn.tagName === "BUTTON") btn.disabled = false;
    }
  }

  function getCollectionHandle() {
    const answers = JSON.parse(localStorage.getItem("quizAnswers")) || [];
    const collectionAnswer = answers.find(a => a.handle);
    if (collectionAnswer) return collectionAnswer.handle;
    const sel = document.querySelector(
      '.quiz__step input[name="quiz-answer"][data-answer-type="collection"]:checked'
    );
    return sel ? sel.dataset.collectionHandle || "" : "";
  }

  const routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  const filtersCache = {};
  async function fetchCollectionFilters(handle, extraQuery) {
    const cacheKey = handle + "|" + (extraQuery || "");
    if (filtersCache[cacheKey]) return filtersCache[cacheKey];
    let url = routeRoot + "collections/" + handle + "?view=" + filtersView;
    if (extraQuery) url += "&" + extraQuery;
    const res = await fetch(url);
    const data = await res.json();
    filtersCache[cacheKey] = data;
    return data;
  }

  function accumulatedQuery(beforeIndex) {
    const answers = JSON.parse(localStorage.getItem("quizAnswers")) || [];
    const answerByStepId = {};
    answers.forEach(a => { answerByStepId[a.quiz] = a; });

    const filterValues = [];
    for (let i = 0; i < beforeIndex; i++) {
      if (skipped.has(i)) continue;
      const answer = answerByStepId[quizSteps[i].id];
      if (answer && answer.value && answer.type !== "collection") {
        filterValues.push(answer.value);
      }
    }
    return filterValues.join("&");
  }

  async function prepareStepDynamic(i) {
    const step = quizSteps[i];
    const answerEls = Array.from(step.querySelectorAll(".quiz__answer"));
    if (answerEls.length === 0) return true;

    const isFilterStep = answerEls.some(a => {
      const inp = a.querySelector('input[name="quiz-answer"]');
      return inp && inp.dataset.answerType === "filter";
    });
    if (!isFilterStep) return true;

    const handle = getCollectionHandle();
    if (!handle) return true;

    const query = accumulatedQuery(i);
    let data = null;
    try {
      data = await fetchCollectionFilters(handle, query);
    } catch (err) {
      data = null;
    }

    if (!data || !data.filters) {
      answerEls.forEach(a => {
        a.hidden = false;
        const inp = a.querySelector('input[name="quiz-answer"]');
        if (inp) inp.disabled = false;
      });
      return true;
    }

    let visible = 0;
    answerEls.forEach(a => {
      const inp = a.querySelector('input[name="quiz-answer"]');
      const raw = inp ? inp.value : "";
      const ok = answerMatchesCollection(data, raw);
      a.hidden = !ok;
      if (inp) inp.disabled = !ok;
      if (ok) {
        visible++;
      } else if (inp && inp.checked) {
        inp.checked = false;
        let saved = JSON.parse(localStorage.getItem("quizAnswers")) || [];
        saved = saved.filter(x => x.quiz !== step.id);
        localStorage.setItem("quizAnswers", JSON.stringify(saved));
      }
    });

    return visible > 0;
  }
  // CUSTOM DEVELOPMENT FOR CUSTOMER END

  function showStep(index) {
    quizStart.style.display = index === -1 ? "flex" : "none";
    quizEnd.style.display = index === totalSteps ? "flex" : "none";

    quizSteps.forEach((step, i) => {
      step.style.display = i === index ? "flex" : "none";
    });

    currentStepIndex = index;
    localStorage.setItem("quizCurrentStep", index); // save current step to local storage

    if (index >= 0 && index < totalSteps) {
      updateProgressBar(quizSteps[index], index);
    }
  }

  function updateProgressBar(stepElement, index) {
    const progressCurrent = stepElement.querySelector(".quiz__progress-current");
    const progressTotal = stepElement.querySelector(".quiz__progress-total");
    const progressBarFill = stepElement.querySelector(".quiz__progress-bar--fill");

    if (progressCurrent && progressTotal && progressBarFill) {
      // CUSTOM DEVELOPMENT FOR CUSTOMER START
      const visible = visibleIndices();
      const pos = visible.indexOf(index);
      const total = visible.length || 1;
      const current = pos === -1 ? index + 1 : pos + 1;
      progressCurrent.textContent = current;
      progressTotal.textContent = total;
      let progressPercent = (current / total) * 100;
      progressBarFill.style.width = `${progressPercent}%`;
      // CUSTOM DEVELOPMENT FOR CUSTOMER END
    }
  }

  function saveAnswer() {
    if (currentStepIndex >= 0 && currentStepIndex < totalSteps) {
      const currentStep = quizSteps[currentStepIndex];
      const selectedOption = currentStep.querySelector('input[name="quiz-answer"]:checked');

      let answers = JSON.parse(localStorage.getItem("quizAnswers")) || [];
      answers = answers.filter(item => item.quiz !== currentStep.id);

      if (selectedOption) {
        answers.push({
          quiz: currentStep.id,
          value: selectedOption.value,
          // CUSTOM DEVELOPMENT FOR CUSTOMER START
          type: selectedOption.dataset.answerType || "",
          handle: selectedOption.dataset.collectionHandle || ""
          // CUSTOM DEVELOPMENT FOR CUSTOMER END
        });
      }

      localStorage.setItem("quizAnswers", JSON.stringify(answers));
    }
  }

  function updateResultsHref() {
    let answers = JSON.parse(localStorage.getItem("quizAnswers")) || [];
    const currentQuizIds = Array.from(quizSteps).map(step => step.id);

    // CUSTOM DEVELOPMENT FOR CUSTOMER START
    let resultUrl = buildQuizResultUrl(answers, currentQuizIds);
    // CUSTOM DEVELOPMENT FOR CUSTOMER END

    showResultsBtn.href = resultUrl;
  }

  // CUSTOM DEVELOPMENT FOR CUSTOMER START
  function pushWizardStepEvent(index) {
    if (index < 0 || index >= totalSteps) return;
    const step = quizSteps[index];
    const selected = step.querySelector('input[name="quiz-answer"]:checked');
    if (!selected) return;

    const label = step.querySelector(`label[for="${selected.id}"]`);
    const selectedOption = (label ? label.textContent : selected.value)
      .replace(/\s+/g, " ")
      .trim();

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: `wizard_step_${index + 1}`,
      selected_option: selectedOption
    });
  }
  // CUSTOM DEVELOPMENT FOR CUSTOMER END

  window.nextQuestion = async function () {
    if (currentStepIndex >= 0) {
      saveAnswer();
      // CUSTOM DEVELOPMENT FOR CUSTOMER START
      pushWizardStepEvent(currentStepIndex);
      // CUSTOM DEVELOPMENT FOR CUSTOMER END
    }

    // CUSTOM DEVELOPMENT FOR CUSTOMER START
    if (!isDynamic) {
      if (currentStepIndex < totalSteps - 1) {
        showStep(currentStepIndex + 1);
      } else {
        showStep(totalSteps);
        updateResultsHref();
      }
      return;
    }

    if (currentStepIndex === 0) {
      for (const key in filtersCache) delete filtersCache[key];
      skipped = new Set();
    }

    const curBtn = currentStepIndex >= 0
      ? quizSteps[currentStepIndex].querySelector(".quiz__next .button")
      : null;
    setButtonLoading(curBtn, true);

    let target = null;
    for (let i = currentStepIndex + 1; i < totalSteps; i++) {
      skipped.delete(i);
      const hasOptions = await prepareStepDynamic(i);
      if (hasOptions) { target = i; break; }
      skipped.add(i);
    }

    setButtonLoading(curBtn, false);

    if (target === null) {
      showStep(totalSteps);
      updateResultsHref();
    } else {
      showStep(target);
    }
    // CUSTOM DEVELOPMENT FOR CUSTOMER END
  };

  window.prevQuestion = function () {
    // CUSTOM DEVELOPMENT FOR CUSTOMER START
    const prev = prevVisible(currentStepIndex);
    if (prev === null) {
      showStep(-1);
    } else {
      showStep(prev);
    }
    // CUSTOM DEVELOPMENT FOR CUSTOMER END
  };

  window.showResults = function (e) {
    saveAnswer();
    updateResultsHref();

    // CUSTOM DEVELOPMENT FOR CUSTOMER START
    const url = showResultsBtn
      ? showResultsBtn.getAttribute("href")
      : "/collections/all";

    if (!e || typeof e.preventDefault !== "function") {
      pushWizardComplete(getWizardEmail());
      return;
    }

    e.preventDefault();
    let navigated = false;
    const go = () => {
      if (navigated) return;
      navigated = true;
      window.location.href = url;
    };

    if (wizardCompleteFired) {
      go();
      return;
    }

    wizardCompleteFired = true;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "wizard_complete",
      email: getWizardEmail(),
      eventCallback: go,
      eventTimeout: 1200
    });
    setTimeout(go, 1200);
    // CUSTOM DEVELOPMENT FOR CUSTOMER END
  };

  window.resetQuiz = function () {
    localStorage.removeItem("quizAnswers");
    localStorage.removeItem("quizCurrentStep"); // reset current step
    showStep(-1);
  };

  // load previous answers
  window.onload = function () {
    let answers = JSON.parse(localStorage.getItem("quizAnswers")) || [];
    answers.forEach(item => {
      let input = document.querySelector(`#${item.quiz} input[name="quiz-answer"][value="${item.value}"]`);
      if (input) input.checked = true;
    });

    // CUSTOM DEVELOPMENT FOR CUSTOMER START
    const justSubscribed = localStorage.getItem("quizSubscribed") === "1";
    const posted = window.location.search.indexOf("customer_posted=true") !== -1;
    localStorage.removeItem("quizSubscribed");

    if (justSubscribed && posted) {
      showStep(totalSteps);
      updateResultsHref();
      const successMsg = document.querySelector(
        ".quiz__page-end .quiz__newsletter-success"
      );
      if (successMsg) successMsg.hidden = false;
      const subscribedForm = document.querySelector(".quiz__page-end .js-form");
      if (subscribedForm) subscribedForm.style.display = "none";

      const quizContainer = document.getElementById("quiz");
      if (quizContainer) {
        quizContainer.scrollIntoView({ behavior: "smooth", block: "start" });
      }

      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, "", window.location.pathname);
      }
      return;
    }

    localStorage.removeItem("quizEmail");
    // CUSTOM DEVELOPMENT FOR CUSTOMER END

    showStep(-1); // load the initial step
  };

  // CUSTOM DEVELOPMENT FOR CUSTOMER START
  let wizardCompleteFired = false;

  function getWizardEmail() {
    const input = document.querySelector('.quiz__page-end input[type="email"]');
    const typed = input && input.value ? input.value.trim() : "";
    return typed || localStorage.getItem("quizEmail") || "";
  }

  function pushWizardComplete(email) {
    if (wizardCompleteFired) return;
    wizardCompleteFired = true;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "wizard_complete",
      email: email || ""
    });
  }

  document.addEventListener("submit", function (e) {
    const form = e.target;
    if (form instanceof HTMLFormElement && form.closest(".quiz__page-end")) {
      localStorage.setItem("quizSubscribed", "1");
      const emailInput = form.querySelector('input[type="email"]');
      if (emailInput && emailInput.value) {
        localStorage.setItem("quizEmail", emailInput.value.trim());
      }
    }
  });
  // CUSTOM DEVELOPMENT FOR CUSTOMER END
});
